const BASE_URLS = {
  service1: process.env.REACT_APP_API_SERVICE_1,
  service2: process.env.REACT_APP_API_SERVICE_2,
  service3: process.env.REACT_APP_API_SERVICE_3,
  service4: process.env.REACT_APP_API_SERVICE_4,
};

export default BASE_URLS;
